import { useMutation, useQuery } from "@apollo/client";
import { useCallback } from "react";

import { InvestorsAndFundingForm } from "./InvestorsAndFundingForm";

import { handleMutationError } from "@hire/errors";
import {
  CompanyFundingDocument,
  CompanyInput,
  UpdateCompanyFundingDocument,
} from "@hire/schema";
import { Text } from "@otta/design";
import { Loading } from "@otta/shared-components";
import { CardContainer } from "@hire/components/containers/CardContainer";
import { ReloadableError } from "@hire/components/ReloadableError";

export const InvestorsAndFunding = () => {
  const { data, loading, refetch } = useQuery(CompanyFundingDocument);
  const [update] = useMutation(UpdateCompanyFundingDocument, {
    onError: handleMutationError,
  });

  const handleSave = useCallback(
    async (input: CompanyInput) => {
      const dataToUpdate = !!Object.keys(input).length;
      if (!data?.currentUser?.currentCompany?.id || !dataToUpdate) {
        return;
      }

      await update({
        variables: {
          id: data?.currentUser?.currentCompany?.id,
          input,
        },
      });
    },
    [data, update]
  );
  if (loading) {
    return <Loading />;
  }

  if (!data?.currentUser?.currentCompany) {
    return <ReloadableError action={refetch} />;
  }

  return (
    <>
      <Text size={2} bold align="center">
        Investors and funding
      </Text>
      <CardContainer>
        <InvestorsAndFundingForm
          data={data.currentUser.currentCompany}
          onSave={handleSave}
        />
      </CardContainer>
    </>
  );
};
